import { string, shape, func, bool, number, oneOfType } from "prop-types"
import Field from "./Field"
import { Select } from "source/shared/components"
import {
  useOrganizationGradeOptions,
  useOrganizationGradeLabel,
} from "source/shared/hooks/useOrganizationGrades"

const GradeField = ({
  id,
  attendee,
  person,
  existingPerson,
  onChange,
  onCancel,
  isRequired,
  isOptional,
  error,
}) => {
  const gradeOptions = useOrganizationGradeOptions()
  const getGradeLabel = useOrganizationGradeLabel()

  const label = attendee.attendeeType.gradeLabel || "Grade"

  const { grade } = person
  const { grade: existingPersonGrade } = existingPerson

  const options = [
    { label: `Select ${label.toLowerCase()}`, value: "" },
    ...gradeOptions,
  ]

  return (
    <Field
      label={label}
      value={getGradeLabel(grade)}
      persistedValue={getGradeLabel(existingPersonGrade)}
      onCancel={() => onCancel("grade")}
      isRequired={isRequired}
      isOptional={isOptional}
      error={error}
    >
      <Select
        name={`grade-${id}`}
        onChange={({ target: { value } }) => onChange("grade", value)}
        value={grade == 0 || grade ? grade : ""}
        readOnly={!!existingPersonGrade || existingPersonGrade === 0}
        style={{ height: "32px" }}
        options={options}
      />
    </Field>
  )
}

GradeField.propTypes = {
  id: oneOfType([string, number]),
  attendee: shape({
    attendeeType: shape({
      gradeLabel: string,
    }),
  }),
  person: shape({
    grade: oneOfType([string, number]),
  }),
  existingPerson: shape({
    grade: oneOfType([string, number]),
  }),
  onChange: func,
  onCancel: func,
  isRequired: bool,
  isOptional: bool,
  error: string,
}

export default GradeField
